import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setEditedProfile } from '../../../redux/applicationSlice';

const EditNameInputBox = () => {
    const dispatch = useDispatch();
    const { theme, editedProfile } = useSelector((state) => state.application);

    const { ref: nameRef, focused: nameFocused } = useFocusable({
        focusKey: "name-profile",
        isFocusBoundary: true,
        onArrowPress: (direction) => {
            return true;
        },
        onBlur: () => { nameRef.current.blur(); },
        onEnterRelease: () => { nameRef.current.focus(); },
    });

    return (
        <FocusContext.Provider value={"name-profile"} >
            <input
                ref={nameRef}
                type="text"
                value={editedProfile?.Description}
                onChange={(e) => {
                    dispatch(setEditedProfile({ ...editedProfile, Description: e.target.value }));
                }}
                placeholder="Enter Profile Name"
                maxLength={18}
                style={{
                    padding: "10px",
                    fontSize: "16px",
                    borderRadius: "5px",
                    border: nameFocused ? "1px solid #007FFF" : "1px solid #ccc",
                    backgroundColor: "transparent",
                    width: "400px",
                    marginBottom: "20px",
                    marginTop: "20px",
                    color: theme?.general?.color ?? "#ffffff"
                }}
            />
        </FocusContext.Provider>
    );
}

export default EditNameInputBox;
